import Vue from 'vue'
import VueRouter from 'vue-router'
import RouterFunctions from '#app#/router/functions.js'
import SmoothScroll from '#app#/global/smoothScroll.js'

Vue.use(VueRouter);

const initUri = window.PRELOADED_PAGE_DATA;
const initRoutes = [];

/*
 * Convert and push initial server-side rendered URI to router
 */
if (initUri) {
    initRoutes.push(RouterFunctions.convertUriToRoute(initUri));
}

/*
 * Main Vue Router Setup
 */
const router = new VueRouter({
    mode: 'history',
    routes: initRoutes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            RouterFunctions.scrollToAnchor(to.hash);
        } else {
            SmoothScroll(document.body);
        }
    }
})

/*
 * Router Hooks for SEO/metadata updates
 */
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        RouterFunctions.updateMedadata(
            to.meta.title, 
            to.meta.description
        );
    }

    next();
});

/*
 * Router Hooks for analytics and scrolling to anchors
 */
document.addEventListener('DOMContentLoaded', function () {
    router.afterEach((to, from) => {
        if (to.path === from.path && to.hash != from.hash) {
            return;
        }

        gaTracking.sendPageView(to.meta.title, to.path);

        if (typeof fbq !== 'undefined') {
            fbTracking.sendPageView();
        }
    });

    if (window.location.hash) {
        RouterFunctions.scrollToAnchor(window.location.hash);
    }
});

export default router;


// WEBPACK FOOTER //
// ../default-js/js/router/index.js